import React from 'react';

interface Props {
  officeDays: number;
  threshold: number;
}

export const OfficeDaysProgressBar = ({ officeDays, threshold }: Props) => {
  const isCompliant = officeDays >= threshold;
  const fillPercent = Math.min((officeDays / threshold) * 100, 100);

  return (
    <div className="employee-attendance-calendar-page__progress">
      <div className="employee-attendance-calendar-page__progress-header">
        <span className="employee-attendance-calendar-page__progress-title">
          Office days progress
        </span>
        <span
          className={`employee-attendance-calendar-page__progress-count employee-attendance-calendar-page__progress-count--${
            isCompliant ? 'ok' : 'low'
          }`}
        >
          {officeDays} / {threshold}
        </span>
      </div>
      <div
        className="employee-attendance-calendar-page__progress-track"
        role="progressbar"
        aria-valuenow={officeDays}
        aria-valuemin={0}
        aria-valuemax={threshold}
        aria-label={`Office days: ${officeDays} of ${threshold} required`}
      >
        <div
          className={`employee-attendance-calendar-page__progress-fill employee-attendance-calendar-page__progress-fill--${
            isCompliant ? 'ok' : 'low'
          }`}
          style={{ width: `${fillPercent}%` }}
        />
        <span
          className="employee-attendance-calendar-page__progress-threshold"
          aria-hidden
        />
      </div>
      <p
        className={`employee-attendance-calendar-page__progress-caption employee-attendance-calendar-page__progress-caption--${
          isCompliant ? 'ok' : 'low'
        }`}
      >
        {isCompliant
          ? `Compliant — ${officeDays} office days completed (minimum ${threshold})`
          : `Below threshold — ${officeDays} of ${threshold} required office days`}
      </p>
    </div>
  );
};
